import React from 'react'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { COLORS } from 'helpers/globals'
import tippy from 'tippy.js'

class AddButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hover: false }
    this.tooltip = null
  }

  componentDidMount = _ =>
    this.tooltip = tippy.one(this.refs.tooltipContainer, { duration: 0, theme: 'topbar', placement: 'top', trigger: 'manual', hideOnClick: false })

  componentWillUnmount = _ => this.tooltip && this.tooltip.hide()

  componentDidUpdate = prevProps => {
    const { state: { hover }, props: { count, disabled }, tooltip } = this

    if (hover && count !== prevProps.count) disabled ? tooltip.show() : tooltip.hide()
  }

  onMouseEnter = _ => this.setState({ hover: true }, _ => this.props.disabled && this.tooltip.show())
  onMouseLeave = _ => this.setState({ hover: false }, _ => this.tooltip.hide())

  render() {
    const { disabled, onClick, title, classes } = this.props

    return (
      <a
        onClick={_ => !disabled && onClick()}
        className={classes.addIcon + (disabled ? ' disabled' : '')}
        title={title}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        ref='tooltipContainer'
      >
        <FontAwesomeIcon icon='plus' style={{ margin: 'auto' }} />
      </a>
    )
  }
}

const style = {
  addIcon: {
    fontSize: '2rem',
    height: '2.5rem',
    width: '2.5rem',
    display: 'flex',
    borderRadius: '50%',
    background: 'white',
    boxShadow: '0 0 2px 0',
    transition: 'opacity 200ms, box-shadow 200ms, color 200ms',
    '&:hover': { boxShadow: '0 0 4px 0' },
    '&.disabled': {
      opacity: '.75',
      cursor: 'not-allowed',
      color: COLORS.secondary,
      '&:hover': {
        cursor: 'not-allowed',
        boxShadow: '0 0 2px 0'
      }
    }
  }
}

export default (injectSheet(style)(AddButton))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/AddButton.js